<template>
  <div class="p_income_module">
    <div class="topOperation">
        <div class="top-left">
            <ShowNavHead />
            <div class="screenInputs">
                <div class="screenInput">
                    <div class="flname">归属月</div>
                    <el-select filterable v-model="listQuery.strUserJobhunt" placeholder="" size="small" clearable>
                        <el-option label="1月" value="1月"></el-option>
                    </el-select>
                </div>
                <div class="screenInput">
                    <div class="flname">归属项目</div>
                    <el-select v-model="listQuery.strUserName" size="small" filterable clearable placeholder="">
                        <el-option v-for="(item, index) in projectList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName">
                        </el-option>
                    </el-select>
                </div>
                <div class="screenInput">
                  <div class="flname">归属部门</div>
                  <el-cascader v-model="dedpartNameList" size="small" :props="props" clearable filterable :options="departList" placeholder="" @change="departChange"></el-cascader>
                </div>
                <div class="screenInput">
                    <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
                    <i class="i_txt" @click="dropDownScreen">{{showDropScreen==1 ? '收起':'更多'}}<i class="el-icon-caret-bottom"></i></i>
                    </el-tooltip>
                </div>
            </div>
        </div>
        <div class="top-right">
            <el-button v-if="showDropScreen==-1" :disabled="isSearchHandle" type="success" size="small" @click="searchHandle" style="margin-right:24px">搜索</el-button>
        </div>
    </div>
    <!-- <el-collapse-transition> -->
      <!-- 筛选下拉框 -->
      <div class="r_dropDownScreen" v-show="showDropScreen==1">
        <div class="pro_down_box">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="100px">
            <el-form-item label="客户名称:">
              <el-input v-model="listQuery.strUserName" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item label="开票主体:">
              <el-input v-model="listQuery.strUserName" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item label="业务员:">
              <el-select v-model="listQuery.strUserName" size="small" filterable clearable placeholder="">
                <el-option v-for="(item, index) in memberList" :key="index" :label="item.Username" :value="item.Userid">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="合伙人:">
              <el-select v-model="listQuery.strUserName" size="small" filterable clearable placeholder="">
                <el-option v-for="(item, index) in memberList" :key="index" :label="item.Username" :value="item.Userid">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客服:">
              <el-select v-model="listQuery.strUserName" size="small" filterable clearable placeholder="">
                <el-option v-for="(item, index) in memberList" :key="index" :label="item.Username" :value="item.Userid">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="服务部门:">
              <el-cascader v-model="dedpartVal" size="small" :props="props" clearable filterable :options="departList" placeholder="" @change="departSerChange"></el-cascader>
            </el-form-item>
            <el-form-item label="客户集团:">
              <el-input v-model="listQuery.strUserName" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item label="交易类型:">
                <el-select filterable v-model="listQuery.strUserJobhunt" placeholder="" size="small" clearable>
                    <el-option label="内部交易" value="内部交易"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="创建时间:">
              <el-date-picker v-model="listQuery.strUserAgeb" value-format="yyyy-MM-dd" type="date" size="small" placeholder="开始日期" class="r_line_input1"></el-date-picker>
            </el-form-item>
            <el-form-item label="创建时间:">
              <el-date-picker v-model="listQuery.strUserAgee" value-format="yyyy-MM-dd" type="date" size="small" placeholder="结束日期" class="r_line_input2"></el-date-picker>
            </el-form-item>
          </el-form>
        </div>
        <div class="drop-footer">
            <el-button size="small" plain @click="resetHandle">清空</el-button>
            <el-button size="small" type="info" plain @click="showDropScreen=-1">关闭</el-button>
            <el-button :disabled="isSearchHandle" size="small" type="success" @click="searchHandle">搜索</el-button>
        </div>
      </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item>{{pageTitle}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
       <!-- v-if="checkPermission(['publicResources_page_list'],permissionLists)" -->
      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick" class="s_tabs_box">
          <el-tab-pane :disabled="tableLoading" label="财务收入" name="first"></el-tab-pane>
          <el-tab-pane :disabled="tableLoading" label="应收账款" name="second"></el-tab-pane>
        </el-tabs>
        <div class="r_act_box">
          <div class="r_act_left">
            <div class="dec_box" v-if="activeName=='first'">
              <p class="dec_txt">
                <span class="txt01">收入笔数：</span>
                <span class="txt02">{{numQuery.num1}}</span>
              </p>
              <p class="dec_txt">
                <span class="txt01">项目个数：</span>
                <span class="txt02">{{numQuery.price1}}</span>
              </p>
              <p class="dec_txt">
                <span class="txt01">开票金额：</span>
                <span class="txt02">{{numQuery.price1}}</span>
              </p>
              <p class="dec_txt">
                <span class="txt01">收入金额：</span>
                <span class="txt02">{{numQuery.price1}}</span>
              </p>
              <p class="dec_txt">
                <span class="txt01">到款金额：</span>
                <span class="txt02">{{numQuery.price1}}</span>
              </p>
              <p class="dec_txt">
                <span class="txt01">应收账款笔数：</span>
                <span class="txt02">{{numQuery.price1}}</span>
              </p>
            </div>
            <div class="dec_box" v-if="activeName=='second'">
              <p class="dec_txt">
                <span class="txt01">应收账款笔数：</span>
                <span class="txt02">{{numQuery.num1}}</span>
              </p>
              <p class="dec_txt">
                <span class="txt01">应收账款金额：</span>
                <span class="txt02">{{numQuery.price1}}</span>
              </p>
              <p class="dec_txt">
                <span class="txt01">项目个数：</span>
                <span class="txt02">{{numQuery.num1}}</span>
              </p>
            </div>
          </div>
          <div class="r_act_right">
            <div class="r_act_item" v-if="activeName=='first'">
              <el-button size="small" type="primary" @click="addHandle">新增收入</el-button>
              <el-button size="small" type="success" @click="importHandle">批量导入收入</el-button>
            </div>
          </div>
        </div>
        <el-table ref="multipleTable" class="re_table" v-loading="tableLoading" @selection-change="handleSelectionChange" :max-height="tableHeight-100" :data="tableData" style="width:100%">
          <el-table-column key="mul" type="selection" width="55" align="center"></el-table-column>
          <template v-for="(item,index) in tableTitle">
            <el-table-column :prop="item.StrColumId" :label="item.StrColumName" fit :show-overflow-tooltip="true" :key="index" :min-width="item.StrColumName.indexOf('性别')>-1||item.StrColumName.indexOf('年龄')>-1||item.StrColumName.indexOf('籍贯')>-1||item.StrColumName.indexOf('学历')>-1 ? '50px' : item.StrColumName.indexOf('名称')>-1||item.StrColumName.indexOf('原因')>-1||item.StrColumName.indexOf('地')>-1||item.StrColumName.indexOf('时间')>-1?'150px':'110px'" align="center"
              :fixed="item.StrColumName=='姓名'">
              <template slot-scope="{row}">
                <span>{{ isNull(row[item.StrColumId]) ? '' : row[item.StrColumId]}}</span>
              </template>
            </el-table-column>
          </template>
          <el-table-column align="center" label="操作" v-if="activeName=='first'" fixed="right" :width="(activeName=='first')?'240px':'140px'" class-name="re_act_box">
            <template slot-scope="{row}">
                <el-button type="text" size="small" @click="applyDtlHandle(row)">查看</el-button>
                <el-button type="text" size="small" plai @click="editHandle(row)">编辑</el-button>
                <el-button type="text" size="small" @click="splitHandle(row)">拆分</el-button>
                <el-button type="text" size="small" @click="dltHandle(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.currpage"
            :page-size="listQuery.pagecount"
            @size-change="handleSizeChange"
            :page-sizes="[10, 20, 50, 100, 200]"
            layout="total,sizes,prev,pager,next,jumper"
            :total="total"
          ></el-pagination>
      </div>
      </div>
    </div>
    <!-- 新增/修改收入弹框 -->
    <el-dialog :title="stateTitle" :visible.sync="incomeVisible" width="700px" class="res_dialog income_dialog">
      <el-form :rules="incomeRules" :inline="true" ref="statementForm" :model="incomeQuery" label-width="90px">
        <el-form-item label="归属:" prop="type" style="width:100%;">
          <div class="i_radio_box">
            <el-radio-group v-model="incomeQuery.type">
              <el-radio :label="'1'">项目</el-radio>
              <el-radio :label="'2'">部门</el-radio>
            </el-radio-group>
            <div class="i_box">
              <el-select v-model="incomeQuery.Projectid" v-if="incomeQuery.type == '1'" placeholder="请选择项目" size="small">
                <el-option v-for="item in projectList" :key="item.Id" :label="item.StrprojectName" :value="item.Projectid"></el-option>
              </el-select>
              <el-cascader v-if="incomeQuery.type == '2'" v-model="dedpartDiaVal" size="small" :props="props" clearable filterable :options="departList" placeholder="请选择部门" @change="departDiaChange"></el-cascader>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="交易类型:">
            <el-select v-model="incomeQuery.state" placeholder="" size="small">
                <el-option value="外部交易"></el-option>
                <el-option value="内部交易"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="我方主体:">
            <el-select v-model="incomeQuery.month" placeholder="" size="small">
                <el-option value="sss"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="对方主体:" v-if="incomeQuery.state == '内部交易'">
            <el-select v-model="incomeQuery.month" placeholder="" size="small">
                <el-option value="sss"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="对方主体:" v-if="incomeQuery.state != '内部交易'">
            <el-input v-model="incomeQuery.remark" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item label="归属月份:">
            <el-date-picker v-model="incomeQuery.month" value-format="yyyy-MM" type="month" size="small" placeholder=""></el-date-picker>
        </el-form-item>
        <el-form-item label="发生日期:">
            <el-date-picker v-model="incomeQuery.month" value-format="yyyy-MM" type="month" size="small" placeholder=""></el-date-picker>
        </el-form-item>
        <el-form-item label="金额:">
            <el-input v-model="incomeQuery.num" size="small" min="1" oninput="value=value.replace(/\D+/g,'')" clearable></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="remark" class="i_width">
            <el-input v-model="incomeQuery.remark" size="small" type="textarea" rows="4" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
            @click="incomeVisible = false"
            size="small"
            >取消</el-button
          >
          <el-button
            type="primary"
            @click="saveStatementHandle"
            size="small"
            >确定</el-button>
      </span>
    </el-dialog>
    <!-- 收入拆分弹框 -->
    <el-dialog title="收入拆分" :visible.sync="splitVisible" width="900px" class="res_dialog split_dialog">
      <div>
        <el-table class="i_list" border :data="splitData" style="width:100%">
            <el-table-column align="center" label="" min-width="100px">
                <template slot-scope="{row}">
                    <span>{{row.name}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="金额" min-width="110px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                    <el-input v-if="row.type == '2'" v-model="row.num" size="small" clearable></el-input>
                    <span v-else>{{row.num}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="归属项目" min-width="160px">
                <template slot-scope="{row}">
                    <el-select v-if="row.type == '2'" v-model="row.namepro" placeholder="" size="small">
                        <el-option value="专票"></el-option>
                    </el-select>
                    <span v-else>{{row.namepro}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="归属部门" min-width="160px">
                <template slot-scope="{row}">
                    <el-select v-if="row.type == '2'" v-model="row.depart" placeholder="" size="small">
                        <el-option value="专票"></el-option>
                    </el-select>
                    <span v-else>{{row.depart}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="发生日期" min-width="170px">
                <template slot-scope="{row}">
                    <el-date-picker v-if="row.type == '2'" v-model="row.date1" value-format="yyyy-MM-dd" type="date" size="small" placeholder=""></el-date-picker>
                    <span v-else>{{row.date1}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="归属月份" min-width="170px">
                <template slot-scope="{row}">
                    <el-date-picker v-if="row.type == '2'" v-model="row.date2" value-format="yyyy-MM" type="month" size="small" placeholder=""></el-date-picker>
                    <span v-else>{{row.date2}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="备注" min-width="170px">
                <template slot-scope="{row}">
                    <el-input v-if="row.type == '2'" v-model="row.remark" size="small" rows="1" type="textarea" clearable></el-input>
                    <span v-else>{{row.remark}}</span>
                </template>
            </el-table-column>
        </el-table>
      </div>
      <div class="d_btn_box">
        <el-button type="text" @click="addSplitHandle" size="small">+ 继续拆分</el-button>
        <el-button type="text" @click="importSplitHandle" size="small">导入拆分</el-button>
        <el-button type="text" @click="downHandle" size="small">下载模板</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
            @click="splitVisible = false"
            size="small"
            >取消</el-button
          >
          <el-button
            type="primary"
            @click="saveAddHandle"
            size="small"
            >确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import xz from "./../../common";
import FUN from "./../../fun";
import checkPermission from '@/utils/permission' // 权限判断函数
// import ResourceComTabs from "./components/resourceComTabs.vue"
export default {
  components: {
    // ResourceComTabs
  },
  data() {
    var validatePhone = (rule, value, callback) => {
      const phoneReg = /^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/i;
      // console.log('validatePhone',value)
      if (value.length == 11 && phoneReg.test(value)) {
        //校验通过
        if(this.enterBtnType != 'save'){
          this.checkHandle(value, (res) => {
            // console.log('validatePhone',res)
            if (res) {
              // this.getResumeDtl(this.enterResumeQuery.ResumeId)
              callback()
            } else {
              this.enterNoteTxt = false
              callback()
            }
          })
        }else{
          callback()
        }
      } else {
        callback(new Error('请输入正确的手机号'))
      }
    }
    return {
      pageTitle:'财务收入',
      enterBtnType:'',
      numQuery:{
        num1:0,
        price1:0,
        price2:0,
      },
      dedpartNameList:[],
      // 表头
      tableTitle: [],
      // 表头参数
      titleQuery: {
        strTableId: 'JB_busi_PsnBaseImperr',
        strIsFixed: '' // 1 基础 0 扩展 空 所有
      },
      // 弹框
      importVisible: false,
      // 员工参数
      departMemberQuery: {
        currpage: 1,
        perpage: 10000000,
        keyword: "",
        strWorkState: "在职",
        strstation: "",
        strorgancode: ""
      },
      originList:[],
      // 部门参数
      departQuery:{
        strorgancode:'',
        roletype:''
      },
      departMemberQuery: {
          keyword: '',
          strWorkState: '在职',
          currpage: 1,
          perpage: 100000
      },
      // 部门列表
      departList:[],
      // 人员列表
      memberList:[],
      // 自定义 级联选择props
      propPosition: { label: 'strParametername', value: 'strParameterid', children: 'children', checkStrictly: true },
      props: { label: 'strorganname', value: 'strorgancode', children: 'children', checkStrictly: true },
      tableHeight: 0,
      showDropScreen: -1,
      activeName: 'first',
      // 列表参数
      listQuery:{
        depart:'',//归属部门
        serDepart:'',//服务部门
        strUserName: '', // 姓名
        strUserAgeb: '', // 开始日期
        strUserAgee: '', // 结束日期
        strWorkState: '', // 状态
        tableid:"JB_busi_PsnBaseImperr",
        strExcelPath:"excel/9c895257-5e33-4888-9bd8-adb6df000221/E20231116093210989.xlsx",
        currpage: 1, // 分页
        pagecount: 10,
      },
      // 导出参数
      exportQuery:{},
      switchBtn: true,
      canvasImg: './../../../assets/images/qrcode.png',
      tableLoading: false,
      tableData: [],
      isCanHandle: true,
      total: 0,
      multipleSelection: [],
      laloading: false,
      roleType: localStorage.loginRoletype,
      imgPath: this.$store.state.EMP.imgPath,
      btnLoading:false,
      loginRoleType:'',
      // 是否能点击搜索按钮
      isSearchHandle:false,
      // 按钮权限参数
      butQuery:{
        path:'/publicResources',
        powerEnName:'employee'
      },
      permissionLists:[],
      sheetList:[],//核算单编号
      // 项目列表
      projectList:[],
      // 项目名称列表参数
      proNameQuery:{
        searchVal:'',
        pageSize: 100000000,
        pageNum: 1
      },
      dedpartVal:[],//服务部门
      dedpartDiaVal:[],//归属部门
      splitData:[],
      incomeVisible:false,
      incomeQuery:{
        type:'',// 归属类型
        state:'',//交易类型
        Projectid:'',
        departid:'',
        month:'',//归属月
        num:'',//金额
        remark:'',//备注
        url:''//附件
      },
      incomeRules:{//规则
        type: [
          { required: true, message: '请选择归属', trigger: 'change' }
        ],
        num: [
          { required: true, message: '请输入结算单金额', trigger: 'blur' }
        ]
      },
      splitVisible:false,
      stateTitle:'新增收入',
      stateFileList:[],//结算单附件
      addRules:{//增加结算单规则
        num: [
          { required: true, message: '请输入结算单金额', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '请上传结算单附件', trigger: 'change' }
        ]
      },
      addQuery:{
        type:'',// 归属类型
        Projectid:'',
        departid:'',
        month:'2024-03',//归属月
        num:'',//结算单金额
        remark:'',//备注
        url:''//附件
      },
      voidVisible:false,
      voidQuery:{
        name:'杰博',
        month:'2024-02',
        num:'1111',
        date:'2024-05-05',
        user:'ss'
      }
    }
  },
  created() {
    this.loginRoleType = localStorage.loginRoletype;
    this.splitData = [
      {
        name:'总收入',
        type:'1',
        num:11,
        namepro:'xxxx',
        depart:'xxxx',
        date1:'2024-02-02',
        date2:'2024-02',
        remark:''
      },
      {
        name:'拆出收入',
        type:'2',
        num:11,
        namepro:'xxxx',
        depart:'xxxx',
        date1:'2024-02-02',
        date2:'2024-02',
        remark:''
      },
      {
        name:'剩下收入',
        type:'3',
        num:11,
        namepro:'xxxx',
        depart:'xxxx',
        date1:'2024-02-02',
        date2:'2024-02',
        remark:''
      }
    ]
    if(!this.isNull(this.$route.query.active)){
      this.activeName = this.$route.query.active
    }else{
      this.activeName = 'first'
    }
    this.getButtonPower()
    // 部门列表
    this.getDepartList()
    this.calHeight()
    this.getProNameList()//项目列表
    // 人员列表
    this.getMemberList()
  },
  methods: {
    checkPermission,
    // 获取按钮权限
    getButtonPower(){
      let that = this
      xz.getbtnPowerIdBypage(this.butQuery).then(res => {
        // console.log('按钮',res)
        if(res.status == 'ok'){
          let resmsg = res.msg
          if(!this.isNull(resmsg)){
            for (let index = 0; index < resmsg.length; index++) {
              let element = resmsg[index];
              this.permissionLists.push(element.Enname);
            }
            if(that.checkPermission(['publicResources_page_list'],that.permissionLists)){
              that.getTableTitleLists()// 表头
            }
          }else{
            this.permissionLists = []
          }
        }else{
          this.permissionLists = []
        }
      })
    },
    // 拆分
    splitHandle(){
      this.splitVisible = true
    },
    // 继续拆分
    addSplitHandle(){
        let query = {
            name:'拆出收入',
            type:'2',
            num:'',
            namepro:'',
            depart:'',
            date1:'',
            date2:'',
            remark:''
        };
        let num = Number(this.splitData.length) - 1;
        console.log('dd',num)
        this.splitData.splice(num, 0, query);
    },
    // 下载模板
    downHandle(){

    },
    // 导入拆分
    importSplitHandle(){

    },
    // 提交申请
    submitHandle(row){
      this.$router.push({
        path: "/submitApply",
      });
    },
    // 查看--开票申请
    applyDtlHandle(row){
      this.$router.push({
        path: "/applyDtl",
      });
    },
    // 新增收入显示弹框
    addHandle(){
      this.stateTitle = '新增收入'
      this.incomeVisible = true
    },
    // 确定上传结算单
    saveStatementHandle(){

    },
    handleExceed() {
      this.$message.warning(`当前限制最多上传 1 个文件`);
    },
    // 删除结算单附件
    handleFileRemove(){

    },
    // 上传结算单附件
    success_handle(){

    },
    // 选择归属部门
    departChange(val){
      // console.log('111', val)
      if(val){
        this.listQuery.serDepart = val[val.length-1]
      }else{
        this.listQuery.serDepart = ''
      }
    },
    departSerChange(val){
      // console.log('111', val)
      if(val){
        this.listQuery.depart = val[val.length-1]
      }else{
        this.listQuery.depart = ''
      }
    },
    departDiaChange(val){},
    getRowKeys(row) { //唯一值
      // console.log(row.id)
      return row.userIds;
    },
    // 确定新增拆分
    saveAddHandle(){
      this.splitVisible = false
    },
    // 删除
    dltHandle(){
      
    },
    // 批量导入收入
    importHandle(){
      
    },
    // 编辑
    editHandle(row){
      this.stateTitle = '编辑收入'
      this.incomeVisible = true
    },
    handleClick(tab){
      // console.log('dd',tab)
      this.activeName = tab.name
      this.currName = 'first'
      if(tab.name == 'first'){
        this.pageTitle = '财务收入'
      }
      if(tab.name == 'second'){
        this.pageTitle = '应收账款'
      }
    },
    // 获取项目列表
    getProNameList(){
      xz.getplancomrecordprojectlist(this.proNameQuery, localStorage.loginRoletype).then(res => {
        // console.log('项目名称列表', res)
        if (res.status == 'ok') {
          this.projectList = res.data
        } else {
          this.projectList = []
        }
      })
    },
    //筛选下拉
    dropDownScreen() {
      if (this.showDropScreen == -1) {
        this.showDropScreen = 1;
      } else if (this.showDropScreen == 1) {
        this.showDropScreen = -1;
      }
    },
    // 表格多选
    handleSelectionChange(val) {
      // console.log('yyy',val)
      this.noticeData = val
      this.multipleSelection = val;
    },
    //数组去重
    unique(arr) {
      for (let i = 0; i < arr.length; i++) {
        for(let j = i+1; j < arr.length; j++){
          if(arr[i].toString()==arr[j].toString()){
            arr.splice(j,1);
            j--;
          }
        }
      }
      return arr;
    },
    //分页
    handleCurrentChange(val){
        this.listQuery.currpage = Number(val)
        this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.currpage = 1
      this.listQuery.pagecount = Number(val)
      this.getList()
    },
    // 获取列表
    getList(){
      this.tableLoading = true
      this.isSearchHandle = true
      xz.getErrtPsnImpDataList(this.listQuery).then(res => {
        // console.log('getList', res)
        if (res.status == 'ok') {
            this.tableData = res.msg
            this.total = res.totalcount
          }else{
            this.tableData = []
            this.total = 0
          }
        this.tableLoading = false
        this.isSearchHandle = false
      })
    },
    // 搜索
    searchHandle(){
      this.listQuery.currpage = 1
      // this.showDropScreen = -1
      this.getList()
    },
    // 获取员工列表
    getMemberList() {
      xz.getauthUserInfoByorgancode(this.departMemberQuery).then(res => {
        // console.log('员工', res)
        if (res.status == 'ok') {
          this.memberList = res.msg
        } else {
          this.memberList = []
        }
      })
    },
    // 获取部门列表
    getDepartList(){
      xz.getOrganstrsreach(this.departQuery.strorgancode,{strIsDisable:'1'}).then(res => {
        // console.log('部门', res)
        if (res.status == 'ok') {
            if(res.msg && res.msg.parent){
              this.departList = res.msg.parent[0].children
            }else {
              this.departList = []
            }
        }
      })
    },
    // 获取表头
    getTableTitleLists(){
      xz.getJbbasePageColumnList(this.titleQuery.strTableId,this.titleQuery.strIsFixed).then(res => {
        if (res.status == 'ok') {
          this.tableTitle = res.msg
          this.getList()
        }else{
          this.tableTitle = []
        }
        // console.log('getList', this.tableTitle)
      })
    },
    // 清空
    resetHandle(){
      this.listQuery = this.$options.data.call(this).listQuery
    },
    calHeight(){
      this.tableHeight = Number(document.body.clientHeight)
    //   console.log('height',this.tableHeight)
    },
    //判断是否为空(包含0)
    isNull(o) {
      return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == ('1900-01-01') || o == '1900-01-01T00:00:00';
    }
  }
}
</script>

<style scoped>
.mr15{
    margin-right: 15px;
}
.d_btn_box{
    margin-top: 10px;
}
.i_radio_box{
  display: -webkit-box;
  /* align-items: center; */
}
.i_box{
  margin-left: 30px;
}
.note_txt{
  font-size: 14px;
  color:#666;
  margin-bottom: 10px;
}
.n_txt{
  text-align: center;
  font-size: 14px;
  color:#409EFF;
}
.info_box{
  padding: 5px 10px 20px;
}
.info_tab_box{
  padding: 0 10px;
}
.info_item{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 5px;
}
.dec_box{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.dec_txt{
  margin-right: 20px;
}
.dec_txt .txt01{
    font-size: 14px;
    color:#000;
    font-weight: bold;
  }
.dec_txt .txt02{
    font-size: 14px;
    color:#409EFF;
  }
  .dec_txt .txt03{
    font-size: 14px;
    color:#303133;
  }
.com_empty{
  width: 100%;
  padding: 10px;
  color:#666;
  font-size: 14px;
  text-align: center;
}
.r_act_item .com_btn{
  background-color: #19bd92;
  border-color: #19bd92;
  color:#fff;
}
.r_dropDownScreen{
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
}
.f_table{
  padding-bottom: 40px;
}
.r_dropDownScreen{
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
}
.r_dropDownScreen{
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
}
.c_dlt_icon{
  cursor: pointer;
  font-size: 18px;
  color:#F56C6C;
}
.groupname {
  font-size: 14px;
  margin-right: 10px;
}
.banlabel {
  color: #c0c4cc;
}
.r_l_title{
  font-size: 14px;
  color:#333;
  line-height: 25px;
  font-weight: bold;
  border-bottom: 1px dashed #ddd;
}
.form-item input{
  width: 400px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #ccc;
  padding-left: 14px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin-top: 10px;
}
/* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
#fileInput {
  width: 120px;
  margin-left: 8px;
  filter: Alpha(opacity=0);
  -moz-opacity: 0;
  opacity: 0;
  position: absolute;
  right: 37px;
  z-index: 2;
}
/* 这是主要的，文件上传按钮的样式 */
.file-btn {
  display:inline-block;
  width: 54px;
  height: 30px;
  background: #fff;
  border: 1px solid #ccc;
  /* border-radius:2px; */
  text-align: center !important;
  line-height: 32px;
  color: #333333;
  /* position: relative;
  top: 5px;
  left: 0; */
  margin-left: 8px;
}
/* 单行文字截断，展示文件名的input框用的 */
#applyLicense {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.f_btns{
  display: flex;
  justify-content: flex-end;
}
.f_list_item{
  margin-bottom: 10px;
}
.f_list_item span{
  margin-right: 10px;
}
.r_label_title{
  font-size: 15px;
  color:#409eff;
  font-weight: 500;
  padding-bottom: 10px;
  border-bottom: 1px solid #EBEEF5;
}
.r_label_list{
  margin-top: 10px;
}
.ftabs {
  background: #fff;
  width: 99%;
}
.r_line_box{
  display: flex;
  align-items: center;
}
.r_line_txt{
  width: 20px;
  height: 1px;
  background-color: #DCDFE6;
  margin: 0 5px;
}
.r_more_box{
  display: flex;
  flex: 1;
  flex-wrap: wrap;
}
.r_more_txt{
  display: inline-block;
  width: 50px;
  margin-right: 5px;
  margin-left: 30px;
  font-size: 13px;
  cursor: pointer;
  color:#409eff;
}
.r_more_txt i{
  font-size: 14px;
  color:#409eff;
  transition: all 0.3s;
}
.rotate-img {
  transform: rotate(270deg);
}
.res_dialog_popover{
  display: flex;
  justify-content: flex-end;
}
.divide_item{
  margin-bottom: 10px;
  font-size: 14px;
  color:#333
}
.pop_list_box .d_txt02,
.pop_list_box .d_txt03{
  margin-right: 5px;
}
.pop_list_box .d_txt04{
  color:#409eff;
  font-size: 13px;
  text-decoration: underline;
}
.notice_title{
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color:#409eff;
  font-size: 14px;
}
.notice_title span{
  cursor: pointer;
}
.notice_title i{
  font-size: 16px;
}
</style>

<style>
.split_dialog .el-date-editor.el-input{
    width: 140px;
}
.income_dialog .i_width .el-form-item__content{
    width: 540px;
}
.void_dialog .el-form-item{
  margin-bottom: 10px;
}
.r_search_box{
    display: flex;
}
.f_all_width .el-form-item__label{
  line-height: 26px;
}
.r_search_sel{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 200px;
    height: 26px;
    line-height: 26px;
    box-sizing: border-box;
    border: 1px solid #ddd;
    cursor: pointer;
}
.r_search_sel .r_search_txt{
    flex: 1;
    padding-left: 3px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.r_search_sel i{
    width: 20px;
}
.re_down_form .el-checkbox{
    margin-right: 13px;
}
.r_more_box .dia_label_box{
  flex: 1;
  max-height: 200px;
}
.r_more_box .dia_label_box .dia_groupname{
  font-weight: normal;
}
.dia_label_box .el-checkbox.is-bordered+.el-checkbox.is-bordered{
  margin-left: 0;
}
.dia_label_box .el-checkbox.is-bordered.is-checked,
.dia_label_box .el-checkbox__input.is-focus .el-checkbox__inner{
  border-color: #19BD92;
}
.dia_label_box{
  max-height: 400px;
  overflow-y: auto;
}
.dia_label_box .dia_groupname{
  font-size: 14px;
  line-height: 25px;
  color:#333;
  font-weight: bold;
  margin-top: 5px;
  /* border-bottom: 1px solid #ddd; */
}
.dia_label_box .el-checkbox{
  border: 1px solid #ddd;
  padding: 2px 3px;
  border-radius: 3px;
  height: auto;
  margin: 5px 20px 0 0;
}
.p_income_module .r_dropDownScreen .el-checkbox__label,
.dia_label_box .el-checkbox__label{
  padding-left: 3px;
}
.disableFirstLevel .el-cascader-panel .el-cascader-menu:first-child .el-cascader-node .el-checkbox{
  display: none;
}
.d_rule_txt01{
  font-size: 13px;
  color:#F56C6C;
  margin-bottom: 10px;
}
.com_dialog_btn.el-button{
  background-color: #ebfaf5;
  border: 1px solid #62d2b4;
  color: #19BD92;
  font-weight: bold;
}
.com_dialog_btn.el-button:hover{
  background-color: #19BD92;
  border: 1px solid #62d2b4;
  color: #fff;
}
.el-tabs__item.is-active {
  color: #19bd92 !important;
}
.d_rule_box{
  margin-top: 3px;
  margin-bottom: 8px;
}
.d_rule_box .txt01{
  font-weight: bold;
  font-size: 14px;
  color:#333;
}
.d_rule_box .txt02{
  font-size: 13px;
  color:#666;
}
.re_dialog_form02 .el-cascader{
  width: 100%;
}
.re_act_box .el-button{
  padding: 4px 8px;
}
.p_income_module .el-table .com_Selection.cell{
  padding: 0 25px 0 5px;
}
.p_income_module .el-table .com_Selection.cell .el-checkbox__inner{
    position:relative;
  }
.p_income_module .el-table .com_Selection.cell:before{
    content:"全选";
    position:absolute;
    right:2px;
    top: 1px;
  }
  .re_table.el-table .cell{
  padding: 0 5px;
}
.p_income_module .screenInput .el-select .el-input__inner{
  width: 100%;
}
.re_table.el-table .el-table__cell{
  padding: 3px 0;
}
.res_dialog .el-dialog__body {
    padding: 5px 20px 20px 20px;
}
.divide_dialog .el-table .el-table__cell{
  padding: 0;
}
.note_label .el-form-item__label:before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
}
.enter_dialog .el-dialog__body{
    padding: 5px 20px 10px 20px;
}
.p_income_module .screenInput{
  margin: 0 0 10px 5px;
}
.r_act_right{
  display: flex;
  align-items: center;
}
.r_act_box{
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
  padding: 5px 10px 20px;
}
.e_txt_box{
  font-size: 14px;
  color:#409eff;
  text-align: right;
}
.r_act_item .r_txt01{
  font-size: 14px;
  color:#333;
  margin-right: 5px;
}
.r_act_right .r_txt02{
  font-size: 14px;
  color:#409eff;
  margin-left: 8px;
}
.qrcode_box .r_txt03{
  font-size: 14px;
  color:#333;
  text-align: center;
}
.r_act_left{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.r_act_item{
  display: flex;
  align-items: center;
  margin-right: 8px;
}
.f_all_width{
  width: 100%;
  align-items: center;
}
.f_checks_box{
  flex-wrap: wrap;
  flex: 1;
}
.res_dialog .r_more_txt{
  margin-left: 0;
}
.re_down_form.el-form--inline .f_all_width .el-form-item__content{
  width: calc(100% - 100px);
  line-height: 26px;
}
.p_income_module .screenInput .el-input{
  width: 200px;
}
.p_income_module .income_dialog .el-input{
  width: 220px;
}
.scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
}
.p_income_module .re_down_form .el-select,
.p_income_module .re_down_form .el-cascader,
.p_income_module .re_down_form.el-form--inline .el-form-item__content{
  width: 225px;
}
.re_down_form .el-form-item{
  margin-bottom: 3px;
  margin-right: 0;
}
.enter_dialog .re_down_form .el-form-item{
  margin-bottom: 20px;
  margin-right: 0;
}
</style>